import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { MyLinksComponent } from './features/my-links/my-links.component';
import { ProfileComponent } from './features/profile/profile.component';

const routes: Routes = [
    { path: '', component: HomeComponent,pathMatch: 'full'  },
    { path: 'ui/', component: HomeComponent },
    { path: 'my-links', component: MyLinksComponent },
    { path: 'profile', component: ProfileComponent },

    // otherwise redirect to home
    { path: '**', component: HomeComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
